export default {
  snackResponse: (state) => state.snackResponse,
  isCargando: (state) => state.isCargando,
};
